import type { Reducer } from 'redux';

import type { DiagnosticsDebugLogsAction } from '../../domains/diagnosticsDebugLogs/actions.types';

import type {
  PerformanceDebugLog,
  PerformanceDebugLogPayload,
  PerformanceDebugLogType,
  PerformanceDebugLogs,
} from './types';
import { getMaxLogCapacity } from './types';

export const initialState: PerformanceDebugLogs = {
  isLoggingEnabled: false,
  debugLogs: [],
};

let state = initialState;

type SetPerfDebugLogsState = (newState: PerformanceDebugLogs) => void;
export const setPerfDebugLogsState: SetPerfDebugLogsState = (newState) => (state = newState);

type GetPerfDebugLogsState = () => PerformanceDebugLogs;
export const getPerfDebugLogsState: GetPerfDebugLogsState = () => state;

type GetPerfDebugLogs = () => PerformanceDebugLog[];
export const getPerfDebugLogs: GetPerfDebugLogs = () => state.debugLogs;

type AddPerfDebugLog = (
  state: PerformanceDebugLogs,
  payload: PerformanceDebugLogPayload,
  type: PerformanceDebugLogType
) => PerformanceDebugLog[];
const addPerfDebugLog: AddPerfDebugLog = (state, payload, type) => {
  const maxLogCapacity = getMaxLogCapacity();
  const perfLogs = state.debugLogs.length >= maxLogCapacity ? state.debugLogs.slice(1) : state.debugLogs;

  return [
    ...perfLogs,
    {
      id: `${payload.name}_${new Date().getTime()}`,
      type,
      payload,
    },
  ];
};

export const reducer: Reducer<PerformanceDebugLogs, DiagnosticsDebugLogsAction> = (state = initialState, action) => {
  if (!action || !action.type) {
    return state;
  }

  if (action.type === 'DIAGNOSTICS.SET_LOGGING_ENABLED') {
    return {
      ...state,
      isLoggingEnabled: action.payload,
    };
  }

  if (!state.isLoggingEnabled) {
    return state;
  }

  switch (action.type) {
    case 'DIAGNOSTICS.LOG_COMPONENT_PERFORMANCE':
      return {
        ...state,
        debugLogs: addPerfDebugLog(state, action.payload, 'Component'),
      };
    case 'DIAGNOSTICS.LOG_API_PERFORMANCE':
      return {
        ...state,
        debugLogs: addPerfDebugLog(state, action.payload, 'Api'),
      };
    case 'DIAGNOSTICS.CLEAR_PERFORMANCE_LOGS':
      return {
        ...state,
        debugLogs: [],
      };
    default:
      return state;
  }
};
